import { NotificationIcon } from './Icon'
import { NotificationLabel } from './Label'
import { cn } from '@lib/cn'
import { FC } from 'react'
import { Text } from '../Typography/Text'

type CustomNotificationProps = {
  icon: string
  color: 'error' | 'success' | 'shade'
  label: string
  description: string
}

export const CustomNotification: FC<CustomNotificationProps> = ({
  icon,
  color,
  label,
  description,
}) => {
  const getColorClasses = (color: string) => {
    switch (color) {
      case 'error':
        return 'bg-error/20 text-error'
      case 'success':
        return 'bg-success/20 text-success'
      case 'shade':
        return 'bg-shade-200 text-shade-600'
    }
  }

  const getTextColor = (color: string) => {
    switch (color) {
      case 'error':
        return 'text-error'
      case 'success':
        return 'text-success'
      case 'shade':
        return 'text-shade-600'
    }
  }

  return (
    <div className={cn('flex items-center gap-3', 'sm:grid-cols-[56px,auto] sm:gap-4')}>
      <NotificationIcon icon={icon as any} className={getColorClasses(color)} />
      <div className="flex-1 overflow-hidden">
        <NotificationLabel className={getTextColor(color)}>{label}</NotificationLabel>
        <Text className={cn('mb-0 text-sm font-bold', getTextColor(color))}>{description}</Text>
      </div>
    </div>
  )
}
